import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { tablet } from "../../../media";

export const DockShell = styled(motion.div)`
    width: 100%;
    padding: 0 16px calc(env(safe-area-inset-bottom, 0px) + 16px);
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    align-items: center;

    /* helper text is 24px above the dock */
    gap: 24px;

    ${tablet`
        max-width: 720px;
        margin: 0 auto;
    `}
`;

export const HelperText = styled.div`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    line-height: 140%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #b7bdcbcc;

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 0;
    width: 100%;
`;

export const DockWrapper = styled(motion.div)`
    width: 100%;
    box-sizing: border-box;
`;

export const DockContent = styled.div`
    pointer-events: auto;

    position: relative;
    width: 100%;
    border-radius: 12px;
    background: #23252a;
    border-top: 1px solid #2b2d33;
    box-shadow: 0px -2px 8px 0px #00000040;

    padding: 12px 16px;
    z-index: 2000;

    display: flex;
    align-items: center;

    /* equal spacing for 4 buttons */
    justify-content: space-between;
    gap: 0;
    box-sizing: border-box;
`;

export const DockItem = styled.button`
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    height: 60px;
    width: 60px;

    cursor: pointer;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    will-change: transform;
    transition: transform 80ms ease, opacity 80ms ease;

    &:active {
        transform: scale(0.88);
        opacity: 0.7;
    }

    &:focus-visible {
        outline: 2px solid #b7bdcb;
        outline-offset: 2px;
    }
`;

export const DockIcon = styled.img<{ isActive?: boolean }>`
    display: block;
    background: ${({ isActive }) => (isActive ? "#2B2D33" : "transparent")};
    border-radius: ${({ isActive }) => (isActive ? "999px" : "0")};
`;

export const DockLabel = styled.span`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 11px;
    line-height: 120%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #b7bdcb;
`;
